import {fromJS, Map} from 'immutable';
import { ERROR, FORM_HIDE, FORM_SHOW, START, SUCCESS } from '../../consts';
import { ANNOUNCEMENT_LOAD, PRICE_SUBSCRIPTION } from './actionTypes';

const FORM_PRICE_SUBSCRIPTION = new Map({
  realtyId: null,
  dealType: null,
  realtyType: null,
  open: false,
  loading: false
});

export const DEFAULT_STATE = fromJS({
  loading: 0,
  loaded: false,
  announcementItem: null,
  error: null,
  formPriceSubscription: FORM_PRICE_SUBSCRIPTION,
  meta: {
    seoTitle: '',
    seoDescription: ''
  }
});

export default function announcement (state = DEFAULT_STATE, action) {
  switch (action.type) {
    // загрузка объявления
    case ANNOUNCEMENT_LOAD + START:
      return state.merge({
        loading: true,
        loaded: false,
        announcementItem: null,
        meta: DEFAULT_STATE.get('meta'),
        error: null
      });
    case ANNOUNCEMENT_LOAD + SUCCESS:
      return state.merge({
        loading: false,
        loaded: true,
        announcementItem: action.item,
        meta: action.meta
      });
    case ANNOUNCEMENT_LOAD + ERROR:
      return state.merge({
        loading: false,
        loaded: false,
        announcementItem: null,
        meta: DEFAULT_STATE.get('meta'),
        error: action.payload
      });

    // подписаться на изменение цены
    case PRICE_SUBSCRIPTION + FORM_SHOW:
    case PRICE_SUBSCRIPTION + FORM_HIDE:
    case PRICE_SUBSCRIPTION + START:
    case PRICE_SUBSCRIPTION + ERROR:
    case PRICE_SUBSCRIPTION + SUCCESS:
      const formState = priceSubscriptionFormReducer(state.get('formPriceSubscription'), action);
      return state.mergeIn(['formPriceSubscription'], formState);

    default:
      return state;
  }
}

function priceSubscriptionFormReducer (state, action) {
  switch (action.type) {
    case PRICE_SUBSCRIPTION + FORM_SHOW:
      return state
        .merge(FORM_PRICE_SUBSCRIPTION)
        .merge(action.payload ? action.payload : FORM_PRICE_SUBSCRIPTION)
        .merge({open: true});
    case PRICE_SUBSCRIPTION + FORM_HIDE:
      return FORM_PRICE_SUBSCRIPTION;
    case PRICE_SUBSCRIPTION + START:
      return state.set('loading', true);
    case PRICE_SUBSCRIPTION + SUCCESS:
    case PRICE_SUBSCRIPTION + ERROR:
      return state.set('loading', false);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/CardAnnouncement/reducer.js